import { useReactFlow } from 'reactflow';
import { Button } from '@givebutter/primitives/button';
import { faBracketsSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';

const RecenterButton = () => {
    const { fitView } = useReactFlow();
    const { nodes } = useReactFlowStore(({ nodes }) => ({ nodes }));

    return (
        <Button
            variant="outline"
            color="neutral"
            shape={'square'}
            size="sm"
            onClick={() => {
                fitView({
                    nodes: nodes.length > 0 ? [{ id: nodes[0].id }] : undefined,
                    maxZoom: 1,
                    minZoom: 1,
                    duration: 250,
                });
            }}
            aria-label="Recenter"
        >
            <FontAwesomeIcon icon={faBracketsSquare} />
        </Button>
    );
};

export { RecenterButton };
